import { HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useMessageGroupStyles } from '../useMessageGroupStyles';

export type ConversationAgentMessageContentProps = HTMLChakraProps<'div'>;

export const ConversationAgentMessageContent: React.FC<ConversationAgentMessageContentProps> =
  forwardRef<ConversationAgentMessageContentProps, 'div'>(
    ({ children, ...props }, ref) => {
      const { agentMessageContent } = useMessageGroupStyles();

      return (
        <chakra.div
          sx={agentMessageContent}
          className="message-group-agent-message-content"
          {...props}
          ref={ref}
        >
          {children}
        </chakra.div>
      );
    },
  );
ConversationAgentMessageContent.displayName = 'ConversationAgentMessageContent';
